import { object, string } from "zod";

export const ConfirmDiscountBubble = object({ discountCode: string() });
